<div class="form-container">
    <div style="margin-bottom: 43px;" class="font-semibold text-xl">Customer details</div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      <button pButton type="submit" [disabled]="form.invalid" class="custom-upload-button btn-primary ">
        Next
        <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i></button>
    </form>
  </div>
  